/**
 * Dynamic API Endpoint Configuration
 * Extracts environment from DynamoDB table names and builds the correct API endpoint
 */

import awsconfig from '../amplifyconfiguration.json';

/**
 * Extract environment from DynamoDB table names
 * Tables follow pattern: "DailyReport-{TableName}-{env}"
 */
function getEnvironmentFromConfig() {
  try {
    // Get the first DynamoDB table name
    const firstTable = awsconfig.aws_dynamodb_table_schemas?.[0]?.tableName;
    
    if (!firstTable) {
      console.warn('No DynamoDB tables found in config, defaulting to development');
      return 'develop';
    }

    // Extract env from pattern: "DailyReport-Clinics-develop" -> "develop"
    const parts = firstTable.split('-');
    const env = parts[parts.length - 1]; // Get last part after final dash

    return env;
  } catch (error) {
    console.error('Error extracting environment from config:', error);
    return 'develop'; // fallback
  }
}

/**
 * Build API endpoint based on environment
 * - Production: api-dailyreport.brainqtech.com  
 * - All others: api-dailyreport-{env}.brainqtech.com
 */
function buildApiEndpoint(env) {
  if (env === 'prod' || env === 'production') {
    return 'https://api-dailyreport.brainqtech.com';
  }
  
  return `https://api-dailyreport-${env}.brainqtech.com`;
}

/**
 * Get the dynamic API endpoint for current environment
 */
export function getApiEndpoint() {
  const env = getEnvironmentFromConfig();
  const endpoint = buildApiEndpoint(env);

  return endpoint;
}

/**
 * Get current environment name
 */
export function getCurrentEnvironment() {
  return getEnvironmentFromConfig();
}